import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-org_icon",
  "use": "icon-org_icon-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-org_icon\">\n<title>qunzujigou</title>\n<path d=\"M21.988 28.35v-26.612c0-0.995-0.997-1.739-1.993-1.739h-15.916c-0.747 0-1.243 0.248-1.491 0.747-0.496 0.496-0.496 0.997-0.496 1.491v26.358h-1.243c-0.496 0-0.747 0.248-0.747 0.75-0.248 0.496 0 0.747 0.248 0.995s0.496 0.248 0.995 0.248h29.841c0.496 0 0.747-0.248 0.747-0.747 0.248-0.496-0.248-1.245-0.747-1.245h-0.997v-16.657c0-0.997-0.496-1.491-1.491-1.491h-4.477v17.654l-0.248 0.248h-1.986zM8.063 12.434v-1.993h7.958v1.993h-7.958zM8.063 23.128v-1.991h7.958v1.991h-7.958zM8.063 5.222h7.958v1.99h-7.462c-0.248 0-0.248 0-0.248-0.248-0.248-0.747-0.248-1.243-0.248-1.743zM8.063 15.918h7.958v1.988h-7.958v-1.988z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/org_icon.svg
// module id = fPv7
// module chunks = 14